import { useState } from "react";
import { Overlay } from "../ui/Overlay";
import { fa } from "./fa";
import { ALBUM, type AlbumSlot, albumDone, isOpen, loadBig, loadProgress } from "./stages";
import { playBig, playStage } from "./StageStrip";
import { Thumb } from "./Thumb";

/**
 * آلبومِ نقش‌ها (کاربر، ۹ آبان: «دسته‌ی ۱»): ۲۴ نقشِ دست‌ساز و سه جانور. هر نقشی که دست‌کم یک بار تمام شده،
 * کاشی‌کاری‌شده این‌جا می‌ماند — همان کاشی‌هایی که سرِ بازی جای فلش‌های رفته می‌نشینند (tiles.ts). نقشِ مرحله‌ی بسته
 * پنهان است، مثلِ نوارِ مرحله‌ها. پیشرفت همان پیشرفتِ مرحله‌ها و نقشه‌های بزرگ است؛ ذخیره‌ی جدا ندارد.
 */
export function AlbumEntry() {
  const [open, setOpen] = useState(false);
  const done = albumDone(loadProgress(), loadBig());
  const shown = ALBUM.filter((s) => done.has(s.key)).slice(-3);
  return (
    <>
      <button type="button" className="ar-albumbtn" onClick={() => setOpen(true)}>
        <span className="ar-albumfan" aria-hidden>
          {shown.length
            ? shown.map((s) => <SlotThumb key={s.key} slot={s} tiled />)
            : <i className="ar-albumempty" />}
        </span>
        <span className="ar-albumtext"><b>آلبوم نقش‌ها</b><small>{fa(done.size)} از {fa(ALBUM.length)}</small></span>
        <svg className="ar-albumgo" viewBox="0 0 24 24" aria-hidden><path d="M15 5l-7 7 7 7" /></svg>
      </button>
      {open && <Album onClose={() => setOpen(false)} />}
    </>
  );
}

function SlotThumb({ slot, tiled }: { slot: AlbumSlot; tiled?: boolean }) {
  return slot.animal ? <Thumb animal={slot.animal} tiled={tiled} /> : <Thumb stage={slot.stage} tiled={tiled} />;
}

function Album({ onClose }: { onClose: () => void }) {
  const p = loadProgress();
  const done = albumDone(p, loadBig());
  const [sel, setSel] = useState<AlbumSlot | undefined>(() => ALBUM.filter((s) => done.has(s.key)).at(-1));
  const play = (s: AlbumSlot) => {
    onClose();
    if (s.animal) playBig(s.animal); else playStage(s.stage!);
  };
  return (
    <Overlay base="veil" className="ar-albumwrap" label="آلبوم نقش‌ها" onClose={onClose}>
      <div className="ar-album">
        <header>
          <b>آلبوم نقش‌ها</b>
          <span>{fa(done.size)} از {fa(ALBUM.length)}</span>
          <button type="button" className="ar-icon" onClick={onClose} aria-label="بستن">
            <svg viewBox="0 0 24 24" aria-hidden><path d="M6 6l12 12M18 6L6 18" /></svg>
          </button>
        </header>
        {sel ? (
          <div className="ar-albumview">
            <span className={"ar-albumbig" + (done.has(sel.key) ? " done" : "")}><SlotThumb slot={sel} tiled={done.has(sel.key)} /></span>
            <b>{sel.name}</b>
            <button type="button" className="btn" onClick={() => play(sel)}>{done.has(sel.key) ? "دوباره" : "بازی"}</button>
          </div>
        ) : (
          <p className="ar-albumhint">هر نقشی که تمام کنی، کاشی‌کاری‌شده این‌جا می‌ماند.</p>
        )}
        <div className="ar-albumgrid">
          {ALBUM.map((s) => {
            const has = done.has(s.key);
            const open = s.animal !== undefined || isOpen(p, s.stage!);
            return (
              <button key={s.key} type="button" disabled={!open} onClick={() => setSel(s)} aria-pressed={sel?.key === s.key}
                aria-label={open ? s.name : `مرحله‌ی ${fa(s.stage! + 1)}، بسته`}
                className={"ar-albumslot" + (has ? " done" : "") + (open ? "" : " locked") + (sel?.key === s.key ? " on" : "")}>
                {open ? <SlotThumb slot={s} tiled={has} /> : (
                  <svg className="ar-lock" viewBox="0 0 24 24" aria-hidden>
                    <rect x="5" y="10.5" width="14" height="10" rx="2.5" />
                    <path d="M8.5 10.5V8a3.5 3.5 0 0 1 7 0v2.5" />
                  </svg>
                )}
                <small>{open ? s.name : `مرحله‌ی ${fa(s.stage! + 1)}`}</small>
              </button>
            );
          })}
        </div>
      </div>
    </Overlay>
  );
}
